import { cn } from "@/lib/utils";
import { useTheme } from "@/lib/theme";

type Props = {
  className?: string;
};

export function ThemeToggle({ className }: Props) {
  const { isDark, toggle } = useTheme();

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className={cn(
        "inline-flex items-center justify-center rounded-full border bg-card/80 backdrop-blur text-foreground shadow-sm cursor-pointer",
        "hover:bg-accent hover:text-accent-foreground",
        "transition-colors h-10 w-10",
        className
      )}
    >
      {/* Moon and Sun icons using simple SVGs to avoid extra deps */}
      {isDark ? (
        // Sun icon
        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden>
          <path d="M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42zm10.48 14.32l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM1 13h3v-2H1v2zm19 0h3v-2h-3v2zM11 1h2v3h-2V1zm0 19h2v3h-2v-3zM4.95 19.07l1.41 1.41 1.8-1.79-1.42-1.42-1.79 1.8zM17.66 4.93l-1.41-1.41-1.8 1.79 1.42 1.42 1.79-1.8zM12 6a6 6 0 100 12 6 6 0 000-12z"/>
        </svg>
      ) : (
        // Moon icon
        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden>
          <path d="M12.74 2a9 9 0 108.26 12.74A8 8 0 0112.74 2z"/>
        </svg>
      )}
    </button>
  );
}

export default ThemeToggle;
